/* K Town Distro — card enhancements (Sep 21 2026)
   Adds "24 flavours · 18 in stock" to every product card (PSI / Smoke Arsenal style)
   and renames the bulk "Choose options" button to "Quick order". */
(function () {
  var cache = {};
  function line(p) {
    var n = p.variants.length, a = p.variants.filter(function (v) { return v.available; }).length;
    var st = a === 0 ? 'out' : a < n ? 'low' : 'in';
    var txt = (n === 1 && p.variants[0].title === 'Default Title')
      ? (a ? 'In stock' : 'Sold out')
      : n + ' flavours · ' + (a === 0 ? 'Sold out' : a === n ? 'All in stock' : a + ' in stock');
    var el = document.createElement('p'); el.className = 'ktd-card-stock';
    el.innerHTML = '<span class="ktd-dot ktd-dot--' + st + '"></span>' + txt;
    return el;
  }
  function run() {
    document.querySelectorAll('modal-opener[data-modal^="#QuickAddBulk"] .quick-add__submit').forEach(function (b) {
      var node = [].find.call(b.childNodes, function (x) { return x.nodeType === 3 && x.textContent.trim(); });
      if (node) node.textContent = 'Quick order ';
    });
    document.querySelectorAll('.product-card-wrapper .card__content .card__information').forEach(function (info) {
      if (info.dataset.ktdStock) return;
      var a = info.querySelector('a[href*="/products/"]'); if (!a) return;
      info.dataset.ktdStock = '1';
      var handle = a.getAttribute('href').split('/products/')[1].split(/[?#/]/)[0];
      var target = info.querySelector('.card-information') || info;
      (cache[handle] = cache[handle] || fetch('/products/' + handle + '.js').then(function (r) { return r.ok ? r.json() : null; }))
        .then(function (p) { if (p && p.variants) target.insertBefore(line(p), target.firstChild); })
        .catch(function () {});
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
  new MutationObserver(function () { clearTimeout(window.__ktdT); window.__ktdT = setTimeout(run, 200); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
